module.exports = __webpack_public_path__ + "static/img/img16.19c0c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img16.png
// module id = P48a
// module chunks = 1